import React, { Component } from "react";
import CustomIcons from "../../../components/icons/kIcons.component";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { user_career_list } from "../../user/user.api";
import "./tenders.css";
import { useEffect } from "react";
import { useState } from "react";
import BreadCrumpBack from "../../../components/navigator/back";

function Careers(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    user_career_list().then((res) => {
      setData(res?.data);     
    });
  }, []);
  const handleLink = (linkurl) => {
    let urlLower = linkurl.toLowerCase();
    let urlStart = urlLower.substring(0, 4);
    if (urlStart === "http") {
      window.open(`${urlLower}`, "_blank");
    } else {
      window.open(`//${urlLower}`, "_blank");
    }
  };
  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>{props.state.language === "ma" ? "തൊഴിൽ അവസരങ്ങൾ" : "Careers"}</h3>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container-fluid">
        <div className="table-container overflow-auto">
          <table className="">
            {data.length > 0 ? (
              <tr className="">
                <th className="table-head">{props.state.language==="ma"?"തലക്കെട്ട്":"Title"}</th>
                <th className="table-head ">{props.state.language==="ma"?"വിവരണം":"Description"}</th>
                <th className="table-head " style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ലിങ്ക്" : "Link"}
                </th>
                <th className="table-head " style={{ width: "120px" }}>
                  {props.state.language === "ma" ? "ഫയൽ" : "File"}
                </th>
              </tr>
            ) : (
              <div
                className="d-flex justify-content-center"
                style={{ fontSize: "20px" }}
              >
                No Recent Postings
              </div>
            )}
            {data.map((card, i) => {
              return (
                <>
                  <tr>
                    <td className="m-2 text-left">{card.title}</td>
                    <td className="m-2 text-left">
                      {card.description
                        ? ReactHtmlParser(card.description)
                        : "no description provided"}
                    </td>
                    <td className="m-2 text-left">
                      {card?.link ? (
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleLink(card.link);
                          }}
                          className="break_link"
                        >
                          {props.state.language === "ma" ? "കാണുക" : "Open"}
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="m-2 text-left">
                      {card?.file && (
                        <span className="">
                          &nbsp;
                          <a
                            onClick={(e) => window.open(card?.file, "_blank")}
                            className="break_link"
                          >
                            {props.state.language === "ma" ? "ഡൗൺലോഡ്" : "Download"}
                          </a>
                        </span>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}
export default Careers;
